import { render, staticRenderFns } from "./pet-purchases-view.vue?vue&type=template&id=6fceb6fa&scoped=true&lang=pug"
import script from "./pet-purchases-view.js?vue&type=script&lang=js&external"
export * from "./pet-purchases-view.js?vue&type=script&lang=js&external"
import style0 from "./pet-purchases-view.vue?vue&type=style&index=0&id=6fceb6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fceb6fa",
  null
  
)

export default component.exports